import React, { useState, useMemo } from 'react';
import HeroSection from '@/components/ui-custom/HeroSection';
import ExodusExperienceSection from '@/components/home/ExodusExperienceSection';
import RallyRegistrationSection from '@/components/home/RallyRegistrationSection';
import UpcomingRidesSection from '@/components/home/UpcomingRidesSection';
import CommunitySocialSection from '@/components/home/CommunitySocialSection';
import CallToActionSection from '@/components/home/CallToActionSection';
import { useRideData } from '@/hooks/useRideData';
import { useAuth } from '@/contexts/AuthContext';
import { Ride } from '@/lib/types/core';
import { Point } from '@/lib/types/core';
import { useNearby } from '@/hooks/useNearby';

const HomePage: React.FC = () => {
  const [nearbyPoint, setNearbyPoint] = useState<Point | null>(null);
  const { user, loading: userLoading } = useAuth();
  const { nearbyLoading } = useNearby(user, userLoading, nearbyPoint, setNearbyPoint);

  // Stable empty array reference to prevent infinite re-renders
  const emptyTerrainFilter = useMemo(() => [] as const, []);

  // Fetch upcoming rides using the API
  const { rides: upcomingRides, loading: loadingRides } = useRideData(
    'All', // difficultyFilter
    'All', // skillFilter
    'All', // rideTypeFilter
    'Future', // timeFilter - show future rides
    'All', // multiDayFilter
    emptyTerrainFilter, // terrainFilter - no terrain filter for homepage
    nearbyPoint, // nearbyPoint
    setNearbyPoint, // setNearbyPoint
    user, // user
    userLoading // userLoading
  );

  return (
    <div className="bg-adv-sand min-h-screen">
      <HeroSection
        title="Adventure Is Out There. Make the Exodus."
        subtitle="Join the premier community of adventure motorcycle riders. Discover new trails, connect with fellow adventurers, and push your limits."
        backgroundImage="/images/hero-bg.jpg"
        isHomepage={true}
      />
      
      <main id="content">
        <ExodusExperienceSection />
        {!nearbyLoading && (
          <UpcomingRidesSection 
            upcomingRides={upcomingRides}
            loadingRides={loadingRides}
            defaultCenter={nearbyPoint}
          />
        )}
        <RallyRegistrationSection />
        <CommunitySocialSection />
        <CallToActionSection />
      </main>
    </div>
  );
};

export default HomePage; 